var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import ModelTraits from "../../ModelTraits";
import primitiveTrait from "../../Decorators/primitiveTrait";
let TablePointSizeStyleTraits = (_dec = primitiveTrait({
  name: "Point Size Column",
  description: "The column to use to size points. This column must be of type `scalar`",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Null Size",
  description: "The point size, in pixels, to use when the column has no value.",
  type: "number"
}), _dec3 = primitiveTrait({
  name: "Size Factor",
  description: "The size, in pixels, of the point is:\n" + "  `Normalized Value * Size Factor + Size Offset`\n" + "where the Normalized Value is a value in the range 0 to 1 with " + "0 representing the lowest value in the column and 1 representing " + "the highest.",
  type: "number"
}), _dec4 = primitiveTrait({
  name: "Size Offset",
  description: "The size, in pixels, of the point is:\n" + "  `Normalized Value * Size Factor + Size Offset`\n" + "where the Normalized Value is a value in the range 0 to 1 with " + "0 representing the lowest value in the column and 1 representing " + "the highest.",
  type: "number"
}), _class = class TablePointSizeStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "pointSizeColumn", _descriptor, this);
    _initializerDefineProperty(this, "nullSize", _descriptor2, this);
    _initializerDefineProperty(this, "sizeFactor", _descriptor3, this);
    _initializerDefineProperty(this, "sizeOffset", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "pointSizeColumn", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "nullSize", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 9;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sizeFactor", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 14;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sizeOffset", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10;
  }
}), _class);
export { TablePointSizeStyleTraits as default };